<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('materiel.format.title') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-3">
        <parametre-autocomplete
          :label="$t('materiel.format.format')"
          v-model="materiel.formatId"
          :target="PARAMETRES_KEYS.materielFormat"
          required
          expanded
        />
      </div>
      <div class="column is-3">
        <b-field :label="$t('materiel.format.surfaceCommerciale')" custom-class="ellipsis">
          <qd-numberinput v-model="getSurfaceCommercial"
                         disabled
                         :controls="false" step="0.01">
          </qd-numberinput>
        </b-field>
      </div>
      <div class="column is-3">
        <b-field :label="$t('materiel.format.surfaceCommercialePerso')" custom-class="ellipsis">
          <b-input v-model="materiel.surface.surfaceCommerciale" step="0.01"
                   type="number">
          </b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'MaterielEditFormat',
  props: {
    materiel: {
      type: Object,
      required: true,
    },
  },
  components: {
    parametreAutocomplete,
  },
  data() {
    return {
      PARAMETRES_KEYS,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    materielFormat() {
      return this.parametre(PARAMETRES_KEYS.materielFormat);
    },
    getSurfaceCommercial() {
      const formatFind = this.materielFormat.find((materielFormat) => {
        return materielFormat.id === this.materiel.formatId;
      });
      return formatFind ? formatFind.surface.surfaceCommerciale : null;
    },
  },
};

</script>
